/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { ListHomepageRecentsQueryResponse } from '../types/ListHomepageRecents'

function getListHomepageRecentsUrl() {
  const res = { method: 'GET', url: `/api/v1/homepage/recents/` as const }
  return res
}

/**
 * @summary List the current user's recently visited items
 * {@link /api/v1/homepage/recents/}
 */
export async function listHomepageRecents(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListHomepageRecentsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListHomepageRecentsUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
